import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  bottomBar: {
    width: '100%',
    position: 'absolute',
    bottom: 40,
    left: 48,
    zIndex: 9999,
    marginLeft: 24,
    borderRadius: 32,
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  bottomBarNavButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: 16,
  },
  bottomBarNavButtons: {
    marginLeft: 16,
    marginRight: 16,
    display: 'flex',
    flex: 1,
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  floatingButtonBottomBar: {
    width: 40,
    height: 40,
    borderRadius: 20,
    zIndex: 99,
    backgroundColor: theme.palette.background.default,
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 8,
  },
  selectButton: {
    minWidth: 120,
    fontSize: 12,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  active: {
    color: '#FFF',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));
